import { render } from "./Clock.vue?vue&type=template&id=11077f03&scoped=true"
import script from "./Clock.vue?vue&type=script&lang=js"
export * from "./Clock.vue?vue&type=script&lang=js"

import "./Clock.vue?vue&type=style&index=0&id=11077f03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11077f03"]])

export default __exports__